/*
  Hikakai "Check Your Shampoo" quiz engine.
  Vanilla JS, no framework, no build step. Reads config from
  <script id="quiz-config" type="application/json"> embedded server-side
  by sections/shampoo-quiz.liquid.
*/
(function () {
  'use strict';

  var STORAGE_KEY = 'hikakai_quiz_state_v1';
  var REF_STORAGE_KEY = 'hikakai_ref';

  var root = document.getElementById('shampoo-quiz-root');
  if (!root) return;

  var CONFIG = null;
  var QUESTIONS_BY_ID = {};

  // ---------- Attribution ----------
  function captureAttribution() {
    var params = new URLSearchParams(window.location.search);
    var ref = params.get('ref');
    if (ref) {
      try { localStorage.setItem(REF_STORAGE_KEY, ref); } catch (e) {}
    }
  }
  function getRef() {
    try { return localStorage.getItem(REF_STORAGE_KEY) || ''; } catch (e) { return ''; }
  }
  function withRef(url) {
    var ref = getRef();
    if (!ref) return url;
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'ref=' + encodeURIComponent(ref) + '&utm_source=referral&utm_medium=quiz_result';
  }
  captureAttribution();

  // ---------- State ----------
  function loadState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) { return null; }
  }
  function saveState(state) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
  }

  var state = loadState() || {
    screen: 'screen0',
    path: [],       // ordered list of question ids visited, for Back
    answers: {},    // questionId -> option label(s)
    flags: {}       // flag -> true
  };

  function persist() { saveState(state); }

  // ---------- Rendering helpers ----------
  function el(tag, className, html) {
    var e = document.createElement(tag);
    if (className) e.className = className;
    if (html !== undefined) e.innerHTML = html;
    return e;
  }

  function renderBold(text) {
    return String(text).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  }

  function clearRoot() {
    root.innerHTML = '';
  }

  function questionIndexForProgress() {
    // Approximate progress across the 7 conceptual questions (q1-q7),
    // regardless of which branch (q4a/q4b/q4c) is active.
    var order = ['q1_format', 'q2_list_length', 'q3_sulfate', 'q4', 'q5_ethoxylation', 'q6_fragrance', 'q7_front'];
    var current = state.path.length;
    return Math.min(current, order.length);
  }

  function renderProgress(container) {
    var total = 7;
    var done = questionIndexForProgress();
    var bar = el('div', 'quiz-progress');
    var fill = el('div', 'quiz-progress__fill');
    fill.style.width = Math.round((done / total) * 100) + '%';
    bar.appendChild(fill);
    container.appendChild(bar);
  }

  // ---------- Screen 0 ----------
  function renderScreen0() {
    clearRoot();
    var wrap = el('div', 'quiz-screen quiz-screen--intro');
    if (CONFIG.screen0.eyebrow) {
      wrap.appendChild(el('p', 'quiz-eyebrow', CONFIG.screen0.eyebrow));
    }
    wrap.appendChild(el('h1', 'quiz-heading', CONFIG.screen0.heading));
    var body = el('div', 'quiz-body');
    CONFIG.screen0.body.split('\n\n').forEach(function (p) {
      body.appendChild(el('p', null, p));
    });
    wrap.appendChild(body);
    var btn = el('button', 'quiz-btn quiz-btn--primary', CONFIG.screen0.cta);
    btn.addEventListener('click', function () {
      state.screen = 'question';
      state.path = ['q1_format'];
      persist();
      renderQuestion('q1_format');
    });
    wrap.appendChild(btn);
    wrap.appendChild(el('p', 'quiz-footnote', CONFIG.screen0.footnote));
    root.appendChild(wrap);
  }

  // ---------- Branch resolution ----------
  function resolveAfterQ3() {
    var isBar = !!state.flags['is_bar'];
    if (isBar) return 'q4c_bar_path';
    var q3Answer = state.answers['q3_sulfate'];
    if (q3Answer && q3Answer.label === 'Yes') return 'q4a_which_sulfate';
    return 'q4b_sulfate_free_trapdoor';
  }

  function goTo(questionId) {
    if (questionId === 'branch_after_q3') questionId = resolveAfterQ3();
    if (questionId === 'result') return renderResult();
    state.path.push(questionId);
    persist();
    renderQuestion(questionId);
  }

  function resetQuiz() {
    state = { screen: 'screen0', path: [], answers: {}, flags: {}, result: null };
    persist();
    renderScreen0();
  }

  function appendRetakeLink(wrap) {
    var retake = el('button', 'quiz-retake', 'Retake the quiz');
    retake.addEventListener('click', resetQuiz);
    wrap.appendChild(retake);
  }

  function goBack() {
    if (state.path.length <= 1) {
      state.screen = 'screen0';
      state.path = [];
      persist();
      renderScreen0();
      return;
    }
    var leaving = state.path.pop();
    delete state.answers[leaving];
    var prev = state.path[state.path.length - 1];
    persist();
    renderQuestion(prev);
  }

  // ---------- Question rendering ----------
  function applyFlags(flagList) {
    (flagList || []).forEach(function (f) { state.flags[f] = true; });
  }

  function renderQuestion(id) {
    var q = QUESTIONS_BY_ID[id];
    if (!q) return renderResult();
    clearRoot();

    var wrap = el('div', 'quiz-screen quiz-screen--question');
    renderProgress(wrap);

    var backBtn = el('button', 'quiz-back', '← Back');
    backBtn.addEventListener('click', goBack);
    wrap.appendChild(backBtn);

    wrap.appendChild(el('h2', 'quiz-prompt', renderBold(q.prompt)));

    if (q.helper_examples) {
      var helper = el('p', 'quiz-helper-examples');
      helper.innerHTML = q.helper_examples.map(function (ex) {
        return '<span class="quiz-helper-example">' + renderBold('**' + ex + '**') + '</span>';
      }).join(' &middot; ');
      wrap.appendChild(helper);
    }

    var optionsWrap = el('div', 'quiz-options');

    if (q.type === 'single') {
      q.options.forEach(function (opt) {
        var btn = el('button', 'quiz-option', renderBold(opt.label));
        btn.addEventListener('click', function () {
          state.answers[q.id] = { label: opt.label };
          applyFlags(opt.flags);
          persist();
          goTo(opt.next);
        });
        optionsWrap.appendChild(btn);
      });
    } else if (q.type === 'multi') {
      var selected = {};
      var continueBtn = el('button', 'quiz-btn quiz-btn--primary quiz-btn--continue', 'Continue');
      continueBtn.disabled = true;

      q.options.forEach(function (opt) {
        var btn = el('button', 'quiz-option quiz-option--multi', renderBold(opt.label));
        btn.addEventListener('click', function () {
          if (opt.exclusive) {
            Object.keys(selected).forEach(function (k) { delete selected[k]; });
            optionsWrap.querySelectorAll('.quiz-option--multi').forEach(function (b) {
              b.classList.remove('is-selected');
            });
            btn.classList.add('is-selected');
            selected[opt.label] = opt;
          } else {
            optionsWrap.querySelectorAll('.quiz-option--multi.is-selected').forEach(function (b) {
              var exclusiveOpt = q.options.filter(function (o) { return o.exclusive && o.label === b.textContent; });
              if (exclusiveOpt.length) { b.classList.remove('is-selected'); delete selected[b.textContent]; }
            });
            if (selected[opt.label]) {
              delete selected[opt.label];
              btn.classList.remove('is-selected');
            } else {
              selected[opt.label] = opt;
              btn.classList.add('is-selected');
            }
          }
          continueBtn.disabled = Object.keys(selected).length === 0;
        });
        optionsWrap.appendChild(btn);
      });

      continueBtn.addEventListener('click', function () {
        var labels = Object.keys(selected);
        state.answers[q.id] = { labels: labels };
        labels.forEach(function (label) {
          applyFlags(selected[label].flags);
        });
        persist();
        goTo(q.next);
      });
      optionsWrap.appendChild(continueBtn);
    }

    wrap.appendChild(optionsWrap);
    root.appendChild(wrap);
  }

  // ---------- Scoring ----------
  function computeScore(flags) {
    var s = CONFIG.scoring;
    var subtotal = 0;
    if (flags['ethoxylated']) subtotal += s.ethoxylated_points;
    if (s.sulfate_flags.some(function (f) { return flags[f]; })) subtotal += s.sulfate_points;
    if (s.syndet_flags.some(function (f) { return flags[f]; })) subtotal += s.syndet_points;
    if (flags['capb']) subtotal += s.capb_points;
    if (flags['fragrance']) subtotal += s.fragrance_points;
    if (flags['long_list']) subtotal += s.long_list_points;

    var total = subtotal;
    if (flags['front_claim'] && subtotal >= s.front_claim_bonus_min_subtotal) {
      total += s.front_claim_bonus;
    }
    return total;
  }

  function bucketFor(score) {
    var match = CONFIG.buckets.find(function (b) { return score >= b.min && score <= b.max; });
    return match ? match.id : 'A';
  }

  // ---------- Result rendering ----------
  function trackCompletion(score, bucketId, flags) {
    try {
      var payload = {
        score: score,
        bucket: bucketId,
        flags: Object.keys(flags),
        format: state.answers['q1_format'] ? state.answers['q1_format'].label : null,
        ref_source: getRef()
      };
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track('Completed Shampoo Quiz', payload);
      } else if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['track', 'Completed Shampoo Quiz', payload]);
      }
    } catch (e) { /* tracking must never break the result render */ }
  }

  function paragraphs(container, text, className) {
    (text || '').split('\n\n').forEach(function (p) {
      container.appendChild(el('p', className, renderBold(p).replace(/\n/g, '<br>')));
    });
  }

  function renderResult() {
    var score = computeScore(state.flags);
    var bucketId = bucketFor(score);
    state.screen = 'result';
    state.result = { score: score, bucket: bucketId };
    persist();
    trackCompletion(score, bucketId, state.flags);

    clearRoot();
    var wrap = el('div', 'quiz-screen quiz-screen--result quiz-result--bucket-' + bucketId.toLowerCase());

    // Part 1: Verdict
    var verdictSection = el('section', 'quiz-verdict');
    paragraphs(verdictSection, CONFIG.verdicts[bucketId], 'quiz-verdict__text');
    wrap.appendChild(verdictSection);

    if (bucketId === 'D') {
      var dSection = el('section', 'quiz-bucket-d');
      dSection.appendChild(el('h3', null, CONFIG.bucket_d.heading));
      paragraphs(dSection, CONFIG.bucket_d.body);
      wrap.appendChild(dSection);
      appendShareLoop(wrap);
      appendRetakeLink(wrap);
      root.appendChild(wrap);
      return;
    }

    // Part 2: conditional explanation modules, in config order, de-duped by heading
    var seenHeadings = {};
    var modulesSection = el('section', 'quiz-modules');
    CONFIG.modules
      .filter(function (m) { return state.flags[m.flag]; })
      .sort(function (a, b) { return a.order - b.order; })
      .forEach(function (m) {
        if (seenHeadings[m.heading]) return;
        seenHeadings[m.heading] = true;
        var mod = el('div', 'quiz-module');
        mod.appendChild(el('h3', null, m.heading));
        paragraphs(mod, m.body);
        modulesSection.appendChild(mod);
      });
    wrap.appendChild(modulesSection);

    // Part 3: what to look for instead
    var part3 = el('section', 'quiz-part3');
    part3.appendChild(el('h3', null, CONFIG.part3_what_to_look_for.heading));
    paragraphs(part3, CONFIG.part3_what_to_look_for.body);
    wrap.appendChild(part3);

    var productUrl = withRef('/products/' + CONFIG.meta.product_handle);

    // Solution-aware bridge: curiosity CTA into the advertorial, before any
    // product pitch. Don't skip straight from problem-aware to product-aware.
    var solutionCta = document.createElement('a');
    solutionCta.href = '#' + CONFIG.advertorial.anchor_id;
    solutionCta.className = 'quiz-btn quiz-btn--primary quiz-solution-cta';
    solutionCta.textContent = CONFIG.solution_aware_cta.label;
    solutionCta.addEventListener('click', function (e) {
      var target = document.getElementById(CONFIG.advertorial.anchor_id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
    wrap.appendChild(solutionCta);

    // Advertorial: full inline article, ending in the actual product CTAs.
    var advertorial = el('section', 'quiz-advertorial');
    advertorial.id = CONFIG.advertorial.anchor_id;
    var productAwareMarker = null;
    CONFIG.advertorial.sections.forEach(function (s) {
      var sectionEl = el('div', 'quiz-advertorial__section');
      if (s.heading) sectionEl.appendChild(el('h2', null, s.heading));
      if (s.image) {
        var img = document.createElement('img');
        img.src = s.image;
        img.alt = s.image_alt || '';
        img.className = 'quiz-part4__image';
        img.loading = 'lazy';
        sectionEl.appendChild(img);
      }
      paragraphs(sectionEl, s.body);
      if (s.cta_after) {
        var inlineCta = document.createElement('a');
        inlineCta.href = productUrl;
        inlineCta.className = 'quiz-btn quiz-btn--primary';
        inlineCta.textContent = CONFIG.advertorial.product_cta_text + ' →';
        sectionEl.appendChild(inlineCta);
      }
      advertorial.appendChild(sectionEl);
      if (s.product_aware_marker) productAwareMarker = sectionEl;
    });
    wrap.appendChild(advertorial);

    // Referral loop at the very bottom: catches readers who made it through
    // the whole advertorial without clicking Check Availability.
    appendShareLoop(wrap);
    appendRetakeLink(wrap);

    // Sticky CTA: starts solution-aware (curiosity into the advertorial),
    // switches to product-aware (the actual product page) once the reader
    // scrolls into the product-pitch part of the advertorial.
    var sticky = el('div', 'quiz-sticky-cta');
    var stickyLink = document.createElement('a');
    stickyLink.className = 'quiz-sticky-cta__link';
    var stickySecondary = el('p', 'quiz-sticky-cta__secondary');
    sticky.appendChild(stickyLink);
    sticky.appendChild(stickySecondary);
    document.body.appendChild(sticky);

    function renderStickyState(mode) {
      var s = CONFIG.sticky_cta[mode];
      if (mode === 'product') {
        stickyLink.href = productUrl;
        stickyLink.onclick = null;
      } else {
        stickyLink.href = '#' + CONFIG.advertorial.anchor_id;
        stickyLink.onclick = function (e) {
          var target = document.getElementById(CONFIG.advertorial.anchor_id);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        };
      }
      stickyLink.textContent = s.label + ' →';
      stickySecondary.textContent = (s.secondary || '')
        .replace('{{batch_size}}', CONFIG.meta.batch_size)
        .replace('{{last_sellout_days}}', CONFIG.meta.last_sellout_days);
    }
    renderStickyState('solution');

    if (productAwareMarker && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var pastMarker = entry.boundingClientRect.top < window.innerHeight;
          renderStickyState(pastMarker ? 'product' : 'solution');
        });
      }, { threshold: 0 });
      observer.observe(productAwareMarker);
    } else {
      renderStickyState('product');
    }

    root.appendChild(wrap);
  }

  function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    // Fallback for browsers/contexts without the async Clipboard API.
    return new Promise(function (resolve, reject) {
      try {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(textarea);
        ok ? resolve() : reject(new Error('execCommand copy failed'));
      } catch (e) {
        reject(e);
      }
    });
  }

  function flashButtonText(btn, message, revertTo, delay) {
    btn.textContent = message;
    setTimeout(function () { btn.textContent = revertTo; }, delay || 2000);
  }

  function appendShareLoop(wrap) {
    var share = el('section', 'quiz-share-loop');
    share.appendChild(el('h3', null, CONFIG.share_loop.heading));
    share.appendChild(el('p', null, CONFIG.share_loop.body));
    var actions = el('div', 'quiz-share-actions');
    var shareUrl = window.location.origin + window.location.pathname + window.location.search;

    var copyBtn = el('button', 'quiz-btn quiz-btn--secondary', 'Copy link');
    copyBtn.addEventListener('click', function () {
      copyToClipboard(shareUrl)
        .then(function () { flashButtonText(copyBtn, 'Copied', 'Copy link'); })
        .catch(function () { flashButtonText(copyBtn, 'Couldn\'t copy — link: ' + shareUrl, 'Copy link', 4000); });
    });
    actions.appendChild(copyBtn);

    // Always render this button. Web Share isn't supported everywhere (notably
    // most desktop browsers), so it falls back to copy-to-clipboard rather than
    // silently doing nothing.
    var shareBtn = el('button', 'quiz-btn quiz-btn--secondary', 'Send this to someone');
    shareBtn.addEventListener('click', function () {
      if (navigator.share) {
        navigator.share({ url: shareUrl, title: document.title }).catch(function (err) {
          if (err && err.name === 'AbortError') return;
          copyToClipboard(shareUrl).then(function () {
            flashButtonText(shareBtn, 'Link copied instead', 'Send this to someone');
          });
        });
      } else {
        copyToClipboard(shareUrl).then(function () {
          flashButtonText(shareBtn, 'Link copied — paste it anywhere', 'Send this to someone', 3000);
        });
      }
    });
    actions.appendChild(shareBtn);

    // A real <a href="sms:"> link so devices that support it navigate normally;
    // we also copy the link on click so desktop clicks (where sms: does nothing) still work.
    var textLink = document.createElement('a');
    textLink.href = 'sms:?&body=' + encodeURIComponent(shareUrl);
    textLink.className = 'quiz-btn quiz-btn--secondary';
    textLink.textContent = 'Text it';
    textLink.addEventListener('click', function () {
      copyToClipboard(shareUrl);
    });
    actions.appendChild(textLink);

    share.appendChild(actions);
    wrap.appendChild(share);
  }

  // ---------- Boot ----------
  function boot() {
    if (state.screen === 'screen0' || !state.path.length) {
      renderScreen0();
    } else if (state.screen === 'result') {
      renderResult();
    } else {
      var current = state.path[state.path.length - 1];
      renderQuestion(current);
    }
  }

  var configUrl = root.getAttribute('data-config-url');
  fetch(configUrl)
    .then(function (res) { return res.json(); })
    .then(function (json) {
      CONFIG = json;
      CONFIG.questions.forEach(function (q) { QUESTIONS_BY_ID[q.id] = q; });
      boot();
    })
    .catch(function () {
      root.innerHTML = '<p class="quiz-error">This isn\'t loading right now. Refresh, or read the label yourself: the cleaning agent should be a saponified oil (sodium + an oil name) or a detergent (anything ending in sulfate, isethionate, or sulfonate) — and "fragrance" always means undisclosed compounds.</p>';
    });
})();
